/* istanbul ignore file */
/* SAMPLES:
//////////////////////////////////////////////////////////////////////////////////////////////
//Minimum usable sample:

    UI.message.show({
        header: 'header text',
        body: messageBodyDraw
    });

//////////////////////////////////////////////////////////////////////////////////////////////
*/
import { Popup, PopupMessage } from "sb-resp-ui";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { PopupMessageDefaultConfig } from "sb-resp-ui";
import { deepMerge } from "sb-helpers";
var UI = window["UI"] || {};
UI["CreatePopUp"] = function CreatePopUp(config, msgStackContainer, legacyCallback) {
    this.msgStackContainer = msgStackContainer || document.body;
    this.msgContainer = document.createElement("div");
    this.config = this.setConfig(config, legacyCallback);
};
UI["CreatePopUp"].prototype.show = function () {
    this.msgStackContainer.appendChild(this.msgContainer);
    this.config.popupConfig.popupPortalEl = this.msgContainer;
    var msg = ReactDOM.render(React.createElement(Popup, {
        config: this.config.popupConfig
    }, React.createElement(PopupMessage, {
        config: this.config.popupMessageConfig
    })), this.msgContainer);
    return msg;
};
UI["CreatePopUp"].prototype.hide = function () {
    ReactDOM.unmountComponentAtNode(this.msgContainer);
    return this;
};
UI["CreatePopUp"].prototype.setConfig = function (config, _legacyCallback) {
    var popupConfig = {}, popupMessageConfig = deepMerge(PopupMessageDefaultConfig, {});
    var legacyCallback = _legacyCallback;
    if (config) {
        config.popupPortalEl && (popupConfig.popupPortalEl = config.popupPortalEl);
        config.wrapperClassname && (popupConfig.className = config.wrapperClassname);
        config.hasOverlay && (popupConfig.hasOverlay = config.hasOverlay);
        popupConfig.hasCloseBtn = config.crossBtn === false ? false : true;
        typeof config.offsetTop !== "undefined" && (popupConfig.offsetTop = config.offsetTop);
        config.isInIframe && (popupConfig.isInIframe = config.isInIframe);
        config.closeFromOverlay && (popupConfig.closeFromOverlay = config.closeFromOverlay);
        config.beforeShowCallback && (popupConfig.beforeShowCallback = config.beforeShowCallback);
        config.beforeHideCallback && (popupConfig.beforeHideCallback = config.beforeHideCallback);
        config.afterHideCallback && (popupConfig.afterHideCallback = config.afterHideCallback);
        config.afterShowCallback && (popupConfig.afterShowCallback = config.afterShowCallback);
        popupConfig.legacyCallback = legacyCallback;
        config.header && (popupMessageConfig.header = config.header);
        config.wrapperClassname && (popupMessageConfig.className = config.wrapperClassname);
        config.body && (popupMessageConfig.body = config.body);
        config.type && (popupMessageConfig.type = config.type);
        var ref = this;
        var defaultActionsClasses = {
            close: {
                classes: "rj-popup-message__btn--negative"
            },
            accept: {
                classes: "rj-popup-message__btn--positive"
            },
            confirm: {
                classes: "rj-popup-message__btn--positive"
            },
            cancel: {
                classes: "rj-popup-message__btn--default"
            },
            default: {
                classes: "rj-popup-message__btn--default"
            }
        };
        /* tslint:disable */
        if (typeof config.actions === "object") {
            Object.keys(config.actions).forEach(function (key) {
                popupMessageConfig.actions[key] = {};
                if (typeof config.actions === "object") {
                    popupMessageConfig.actions[key].classes = defaultActionsClasses.hasOwnProperty(key) ? "" + defaultActionsClasses[key].classes : "" + defaultActionsClasses["default"].classes;
                    popupMessageConfig.actions[key].classes = typeof config.actions[key].classes === "string" ? "" + config.actions[key].classes : "" + popupMessageConfig.actions[key].classes;
                    popupMessageConfig.actions[key].text = config.actions[key].text;
                    popupMessageConfig.actions[key].focus = config.actions[key].focus || false;
                    popupMessageConfig.actions[key].onClick = config.actions[key].callback || ref.hide;
                    popupMessageConfig.actions[key].context = config.actions[key].context || ref;
                }
            });
        }
        /* tslint:enable */
    }
    return { popupConfig: popupConfig, popupMessageConfig: popupMessageConfig };
};
UI["message"] = (function () {
    var popupStack = [];
    var msgStackContainer = document.body;
    var popup;
    function show(config, id) {
        msgStackContainer = document.getElementById("rj-popup-message-root") || document.body;
        var popupInfo = id ? popupStack.find(function (p) { return p.id === id && typeof id === "string"; }) : undefined;
        if (!popupInfo) {
            popup = new UI.CreatePopUp(config, msgStackContainer, this.removeFromStack.bind(this, id));
            popupStack.push({ id: id, popup: popup });
        }
        else {
            popup = popupInfo.popup;
        }
        popup.show();
        popupStack.forEach(function (p) { p.popup.msgContainer.classList.add("hidden"); });
        popup.msgContainer.classList.remove("hidden");
        return popup;
    }
    function hide(id) {
        var popupInfo = id ? popupStack.find(function (p) { return p.id === id && typeof id === "string"; }) : undefined;
        if (popupInfo) {
            popupInfo.popup.hide();
        }
        else if (typeof id === "undefined") {
            popupStack.length > 0 && popupStack[popupStack.length - 1].popup.hide();
        }
        return popupStack;
    }
    function removeFromStack(id) {
        if (id && popupStack.length > 0) {
            var popupInfo = popupStack.find(function (p) { return p.id === id && typeof id === "string"; });
            if (popupInfo) {
                var index = popupStack.map(function (x) { return x.id; }).indexOf(id);
                popupStack.splice(index, 1);
                popupStack.push(popupInfo);
            }
        }
        if (popupStack.length > 0) {
            popupStack[popupStack.length - 1].popup.msgStackContainer.removeChild(popupStack[popupStack.length - 1].popup.msgContainer);
            popupStack.pop();
            popupStack.length > 0 && popupStack[popupStack.length - 1].popup.msgContainer.classList.remove("hidden");
        }
        return popupStack;
    }
    return {
        show: show,
        hide: hide,
        removeFromStack: removeFromStack,
        popupStack: popupStack
    };
}());
// override default alert function to use UI.message.show behavior
function alert(message) {
    "use strict";
    UI.message.show({
        body: message,
        actions: {
            accept: { text: "OK", focus: true },
        }
    });
}
Window.prototype.alert = window.alert = alert;
export var ui = UI;
window["UI"] = UI;
//# sourceMappingURL=UI.message.js.map